module.exports = __webpack_public_path__ + "static/img/btntb.f9b0ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/my/btntb.png
// module id = HgIW
// module chunks = 80